import { useEffect, useState } from "react";
import { format, subDays, subYears } from "date-fns";
import { date_range_select_options } from "ui/pages/discounts/discounts.constants";
import { useCustomQuery } from "data/modules/api/hooks/useCustomQuery";
import { LTO_STATS_API_PATHNAMES } from "../../constants/LTOStats.api";
import {
  SHORT_MONTH_DATE,
  YEAR_MONTH_DAY_FORMAT,
} from "features/Common/modules/DateTime/DateTime.constants";
import { LTO_STATS } from "ui/pages/limitedOffer/constants";
import { DAYS_RANGE } from "ui/pages/marketing/affiliates/affiliates.constants";

export const useLTOStats = () => {
  const [selectedRange, onRangeChange] = useState(
    date_range_select_options.last_7.value
  );
  const [dataRange, setDateRange] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const getDataRange = () => {
    const today = new Date();
    if (selectedRange === date_range_select_options.custom.value) {
      setStartDate("");
      setEndDate("");
      return "";
    }
    setEndDate(format(today, YEAR_MONTH_DAY_FORMAT));
    if (selectedRange === date_range_select_options.last_7.value) {
      let endRange = subDays(today, DAYS_RANGE.six);
      setStartDate(format(endRange, YEAR_MONTH_DAY_FORMAT));
      return `${format(today, SHORT_MONTH_DATE)} - ${format(
        endRange,
        SHORT_MONTH_DATE
      )}`;
    } else if (selectedRange === date_range_select_options.last_30.value) {
      let endRange = subDays(today, DAYS_RANGE.twentyNine);
      setStartDate(format(endRange, YEAR_MONTH_DAY_FORMAT));
      return `${format(today, SHORT_MONTH_DATE)} - ${format(
        endRange,
        SHORT_MONTH_DATE
      )}`;
    } else if (selectedRange === date_range_select_options.lifetime.value) {
      let endRange = subYears(today, DAYS_RANGE.one);
      setStartDate(format(endRange, YEAR_MONTH_DAY_FORMAT));
      return `${format(today, SHORT_MONTH_DATE)} - ${format(
        endRange,
        SHORT_MONTH_DATE
      )}`;
    }
  };

  useEffect(() => {
    setDateRange(getDataRange);
  }, [selectedRange]);

  const { data: LTOStatsData } = useCustomQuery({
    queryKey: [LTO_STATS, selectedRange, startDate, endDate],
    url: LTO_STATS_API_PATHNAMES.LTO_STATS_DATA({ startDate, endDate }),
    enabled: !!startDate && !!endDate,
  });

  return {
    LTOStatsData,
    dataRange,
    selectedRange,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    setDateRange,
    onRangeChange,
  };
};
